export default __webpack_public_path__ + "static/font-b0c8cbb7afc20a4614918aa107ff7ca6.woff2";